import React from 'react';
import { CheckCircle2, XCircle, AlertTriangle, ScanLine } from 'lucide-react';
import './LastScanPanel.css';

const STATUS = {
  success: { Icon: CheckCircle2, label: 'OK' },
  error: { Icon: XCircle, label: 'Error' },
  warning: { Icon: AlertTriangle, label: 'Check' },
  idle: { Icon: ScanLine, label: 'Ready' },
};

// The result of the most recent scan, shown next to the scan input until the next
// one. Status is carried by icon + text label + colour, never colour alone.
//
//   <LastScanPanel status="error" title="Not on this order" detail="5012345678900"
//                  meta="Scan the next item" timestamp={lastScan.at} compact={isMobile} />
//
// A new `timestamp` re-plays the entry animation even when the text is unchanged.
const LastScanPanel = ({ status = 'idle', title, detail, meta, timestamp, compact = false, className = '' }) => {
  const { Icon, label } = STATUS[status] || STATUS.idle;
  return (
    <div
      key={timestamp ?? 'idle'}
      className={`last-scan last-scan-${STATUS[status] ? status : 'idle'} ${compact ? 'last-scan-compact' : ''} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <Icon className="last-scan-icon" size={compact ? 28 : 40} aria-hidden="true" />
      <div className="last-scan-text">
        <div className="last-scan-heading">
          <span className="last-scan-label">{label}</span>
          <span className="last-scan-title">{title || 'Waiting for a scan'}</span>
        </div>
        {detail && <div className="last-scan-detail">{detail}</div>}
        {meta && <div className="last-scan-meta">{meta}</div>}
      </div>
    </div>
  );
};

export default LastScanPanel;
